import { render, staticRenderFns } from "./InsertEditComponent.vue?vue&type=template&id=5724d457&scoped=true&"
import script from "./InsertEditComponent.vue?vue&type=script&lang=js&"
export * from "./InsertEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5724d457",
  null
  
)

export default component.exports